const FALLBACK_BACK_HREF = "/browse";
const FALLBACK_BACK_LABEL = "Browse";

type QueryParam = string | string[] | undefined;

function firstQueryValue(value: QueryParam): string {
  return Array.isArray(value) ? value[0] ?? "" : value ?? "";
}

export function sanitizeBackHref(value: string | undefined): string {
  const normalized = (value ?? "").trim();
  if (!normalized) return FALLBACK_BACK_HREF;
  if (!normalized.startsWith("/") || normalized.startsWith("//")) return FALLBACK_BACK_HREF;
  return normalized;
}

export function sanitizeBackLabel(value: string | undefined): string {
  const normalized = (value ?? "").trim();
  return normalized || FALLBACK_BACK_LABEL;
}

export function getPieceBackContext(searchParams?: { back?: QueryParam; backLabel?: QueryParam }) {
  return {
    backHref: sanitizeBackHref(firstQueryValue(searchParams?.back)),
    backLabel: sanitizeBackLabel(firstQueryValue(searchParams?.backLabel))
  };
}

export function buildPieceHref(itemId: string, options?: { backHref?: string; backLabel?: string }): string {
  const params = new URLSearchParams({
    back: sanitizeBackHref(options?.backHref),
    backLabel: sanitizeBackLabel(options?.backLabel)
  });

  return `/pieces/${itemId}?${params.toString()}`;
}
